<template>
  <div class="landing">
    <Navbar />
    <div class="kovatek-width"></div>
    <div class="home-img py-md-2">
      <div class="human-im container-fluid">
        <div class="row pt-5 pb-md-5">
          <div class="col-sm-0 col-md-2 col-lg-3"></div>
          <div class="col-sm-12 col-md-8 col-lg-6 mt-5 pt-md-5 px-5">
            <!-- <vue-typed-js :strings="['<p>Paragraph</p>', '<span>Span</span>']" :contentType="'html'" :loop="true">
            <span class="typing"></span>
          </vue-typed-js> -->
            <vue-typed-js :strings="['awesome', 'brilliant']" :loop="true">
              <!-- @onComplete="doSmth()" -->
              <!-- <h2>We are a <span class="typing"></span> company!</h2> -->
              <!-- <input type="text" class="form-control text-white border-left-0 typing" style="background: transparent;" /> -->
            </vue-typed-js>
            <div class="input-group mb-3" style="">
              <div class="input-group-prepend border-right-0 text-white">
                <span
                  class="input-group-text pointer border-right-0"
                  style="background: transparent;"
                  id="inputGroup-sizing-default"
                >
                  <font-awesome-icon
                    icon="search"
                    style="color: white;"
                  ></font-awesome-icon>
                </span>
              </div>
              <vue-typed-js
                :strings="searchData"
                :loop="true"
                :typeSpeed="50"
                :backSpeed="20"
                style="width: calc(100% - 50px)"
              >
                <input
                  type="text"
                  :class="
                    `form-control text-white border-left-0 w-100 ${
                      typing ? 'typing' : ''
                    }`
                  "
                  style="background: transparent; box-shadow: inset 0 0px 0 #ddd"
                  aria-label="Default"
                  aria-describedby="inputGroup-sizing-default"
                  v-on:focus="typing = false"
                />
              </vue-typed-js>
            </div>
            <h3 class="pt-4 text-white font-weight-bold very-bold1 mx-5">
              Hire Software Talents & Collaborate Remotely
            </h3>
            <p
              class="mt-3 ml-sm-5 ml-4 text-white font-size2 font-weight-light"
            >
              Build world class products using top talent that are; Pre-Vetted,
              Continuously Reviewed, & Rated.
            </p>
            <div class="ctrl-vetted-text banner-add-margin ml-4 my-4">
              <router-link to="/hire">
                <button
                  class="btn-outline-kovatek mt-3 mx-3 py-2 ctrl-size2 kova-text text-uppercase font-weight-bold"
                  style="width: 180px"
                >
                  post a project
                </button>
              </router-link>
              <router-link to="/hire-talent">
                <button
                  class="btn-outline-kovatek mt-3 mx-3 py-2 ctrl-size2 kova-text text-uppercase font-weight-bold"
                  style="width: 180px"
                >
                  hire talents
                </button>
              </router-link>
            </div>
          </div>
          <div class="col-sm-12 col-md-2 col-lg-3"></div>
        </div>
      </div>
    </div>

    <div class="w-75 mx-auto mt-2">
      <vueper-slides
        class="no-shadow"
        :bullets="false"
        :visible-slides="
          width > 1230 ? 4 : width > 920 ? 3 : width > 640 ? 2 : 1
        "
        :slide-ratio="1 / 4"
        :dragging-distance="70"
        :fixed-height="width > 640 ? '230px' : '270px'"
        transition-speed="250"
        autoplay
      >
        <vueper-slide>
          <template v-slot:content>
            <TopRatedDev
              name="Idris. A"
              image="developer-3.png"
              specialization="UI/UX Designer"
              charge="32"
              location="Lagos, Nigeria"
              :skills="['Adobe XD', 'Figma', 'PS']"
              level="senior"
              rating="9.7"
              reviews="20"
            />
          </template>
        </vueper-slide>
        <vueper-slide>
          <template v-slot:content>
            <TopRatedDev
              name="Johnson. K"
              image="developer-1.png"
              specialization="Web Dev"
              charge="25"
              location="Cape Town, S.A."
              :skills="['Django', 'Flask', 'Rails']"
              level="intermediate"
              rating="9.5"
              reviews="56"
            />
          </template>
        </vueper-slide>
        <vueper-slide>
          <template v-slot:content>
            <TopRatedDev
              name="Mike. P"
              image="mike.png"
              specialization="Back-end Dev"
              charge="30"
              location="Texas ,US"
              :skills="['PHP', 'Nodejs', 'Go']"
              level="senior"
              rating="9.6"
              reviews="43"
            />
          </template>
        </vueper-slide>
        <vueper-slide>
          <template v-slot:content>
            <TopRatedDev
              name="Amana"
              image="image-032.png"
              specialization="Product Manager"
              charge="18"
              location="Kampala, Uganda"
              :skills="['Product Management']"
              level="intermediate"
              rating="9.7"
              reviews="73"
            />
          </template>
        </vueper-slide>
        <vueper-slide>
          <template v-slot:content>
            <TopRatedDev
              name="Idirs. A"
              image="developer-3.png"
              specialization="UI/UX Designer"
              charge="32"
              location="Lagos, Nigeria"
              :skills="['Adobe XD', 'Figma', 'PS']"
              level="senior"
              rating="9.4"
              reviews="20"
            />
          </template>
        </vueper-slide>
        <vueper-slide>
          <template v-slot:content>
            <TopRatedDev
              name="Adara. W"
              image="developer-2.jpeg"
              specialization="Front-end Dev"
              charge="18"
              location="Nairobi, Kenya"
              :skills="['React', 'Vue', 'Nodejs']"
              level="senior"
              rating="9.1"
              reviews="73"
            />
          </template>
        </vueper-slide>
        <vueper-slide>
          <template v-slot:content>
            <TopRatedDev
              name="Johnson. K"
              image="developer-1.png"
              specialization="Web Dev"
              charge="25"
              location="Cape Town, S.A."
              :skills="['Django', 'Flask', 'Rails']"
              level="intermediate"
              rating="9.5"
              reviews="56"
            />
          </template>
        </vueper-slide>
        <vueper-slide>
          <template v-slot:content>
            <TopRatedDev
              name="Mike. P"
              image="mike.png"
              specialization="Back-end Dev"
              charge="30"
              location="Texas, US"
              :skills="['PHP', 'Nodejs', 'Go']"
              level="senior"
              rating="9.6"
              reviews="43"
            />
          </template>
        </vueper-slide>
      </vueper-slides>
    </div>

    <!-- Developers Available -->
    <div class="mb-5 pb-5 available-devs-width px-3 px-md-5">
      <div class="m-auto">
        <div class="row m-auto">
          <div class="col-6 col-sm-6 col-md-3 mx-auto mt-4">
            <router-link to="/find-talent?category=mobile-app">
              <div
                class="col-12 available-devs ctrl-shadow mx-auto pt-3 pt-sm-3 pt-md-0 p-0"
              >
                <img
                  class="devs-skills-img mt-3 pt-3"
                  src="../assets/KOVATEK/PNGss/mobile-app.png"
                />
                <h6 class="py-3 kova-text ctrl-size2 font-weight-bold">
                  Mobile App
                </h6>
              </div>
            </router-link>
          </div>

          <div class="col-6 col-sm-6 col-md-3 mx-auto mt-4">
            <router-link to="/find-talent?category=blockchain">
              <div
                class="col-12 available-devs ctrl-shadow mx-auto pt-3 pt-sm-3 pt-md-0 p-0"
              >
                <img
                  class="devs-skills-img mt-3 pt-3"
                  src="../assets/KOVATEK/PNGss/blockchain.png"
                />
                <h6 class="py-3 kova-text ctrl-size2 font-weight-bold">
                  Blockchain
                </h6>
              </div>
            </router-link>
          </div>

          <div class="col-6 col-sm-6 col-md-3 mx-auto mt-4">
            <router-link to="/find-talent?category=artificial-intelligence">
              <div
                class="col-12 available-devs ctrl-shadow mx-auto pt-3 pt-sm-3 pt-md-0 p-0"
              >
                <img
                  class="devs-skills-img mt-3 pt-3"
                  src="../assets/KOVATEK/PNGss/AI.png"
                />
                <h6 class="py-3 kova-text ctrl-size2 font-weight-bold">A.I</h6>
              </div>
            </router-link>
          </div>

          <div class="col-6 col-sm-6 col-md-3 mx-auto mt-4">
            <router-link to="/find-talent?category=web-app">
              <div
                class="col-12 available-devs ctrl-shadow mx-auto pt-3 pt-sm-3 pt-md-0 p-0"
              >
                <img
                  class="devs-skills-img mt-3 pt-3"
                  src="../assets/KOVATEK/PNGss/webapp.png"
                />
                <h6 class="py-3 kova-text ctrl-size2 font-weight-bold">
                  Web Application
                </h6>
              </div>
            </router-link>
          </div>

          <div class="col-6 col-sm-6 col-md-3 mx-auto mt-4">
            <router-link to="/find-talent?category=ui-ux">
              <div
                class="col-12 available-devs ctrl-shadow mx-auto pt-3 pt-sm-3 pt-md-0 p-0"
              >
                <img
                  class="devs-skills-img mt-3 pt-3"
                  src="../assets/KOVATEK/PNGss/ui-ux.png"
                />
                <h6 class="py-3 kova-text ctrl-size2 font-weight-bold">
                  UI/UX Design
                </h6>
              </div>
            </router-link>
          </div>

          <div class="col-6 col-sm-6 col-md-3 mx-auto mt-4">
            <router-link to="/find-talent?category=product-management">
              <div
                class="col-12 available-devs ctrl-shadow mx-auto pt-3 pt-sm-3 pt-md-0 p-0"
              >
                <img
                  class="devs-skills-img mt-3 pt-3"
                  src="../assets/KOVATEK/PNGss/cyber-security.png"
                />
                <h6 class="py-3 kova-text ctrl-size2 font-weight-bold">
                  Product Management
                </h6>
              </div>
            </router-link>
          </div>

          <div class="col-6 col-sm-6 col-md-3 mx-auto mt-4">
            <router-link to="/find-talent?category=data-engineering">
              <div
                class="col-12 available-devs ctrl-shadow mx-auto pt-3 pt-sm-3 pt-md-0 p-0"
              >
                <img
                  class="devs-skills-img mt-3 pt-3"
                  src="../assets/KOVATEK/PNGss/data-eng.png"
                />
                <h6 class="py-3 kova-text ctrl-size2 font-weight-bold">
                  Data Engineering
                </h6>
              </div>
            </router-link>
          </div>

          <div class="col-6 col-sm-6 col-md-3 mx-auto mt-4">
            <router-link to="/find-talent?category=devops">
              <div
                class="col-12 available-devs ctrl-shadow mx-auto pt-3 pt-sm-3 pt-md-0 p-0"
              >
                <img
                  class="devs-skills-img mt-3 pt-3"
                  src="../assets/KOVATEK/PNGss/devops.png"
                />
                <h6 class="py-3 kova-text ctrl-size2 font-weight-bold">
                  DevOps
                </h6>
              </div>
            </router-link>
          </div>
        </div>
        <router-link to="/find-talent">
          <button
            class="px-5 py-2 btn-kovatek mt-5 text-uppercase"
            style="font-size:12px"
          >
            Find Talent
          </button>
        </router-link>
      </div>
    </div>

    <div class="kovatek-width">
      <div class="top-devs m-auto">
        <div class="px-sm-4 mx-4 my-5 pb-4 px-3">
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-3 my-3">
              <div class="kova-summary shadow py-4 px-4">
                <p class="font-weight-bolder">Pre-Vetted Talents</p>
                <h3
                  class="pt-2 kova-text font-weight-bold very-bold1 mx-4 mb-0"
                >
                  Top 3-5%
                </h3>
                <p class="ctrl-size2 font-weight-bolder kova-text">
                  Talents are accepted
                </p>
                <p class=" ctrl-size3 font-weight-lighter">
                  For full time & contract jobs
                </p>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 my-3">
              <div class="kova-summary shadow py-4 px-4">
                <p class="font-weight-bolder">
                  Software talent for remote services
                </p>
                <h3
                  class="pt-2 kova-text font-weight-bold very-bold1 mx-4 mb-0"
                >
                  7,000+
                </h3>
                <p class="ctrl-size2 font-weight-bolder kova-text">
                  devs available
                </p>
                <p class=" ctrl-size3 font-weight-lighter">
                  Proven talent with right expertise for your software services
                </p>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 my-3">
              <div class="kova-summary shadow py-4 px-4">
                <p class="font-weight-bolder">
                  Invite top talent for live interview
                </p>
                <h3
                  class="pt-2 kova-text font-weight-bold very-bold1 mx-4 mb-0"
                >
                  1,000+
                </h3>
                <p class="ctrl-size2 font-weight-bolder kova-text">
                  job offers/week
                </p>
                <p class=" ctrl-size3 font-weight-lighter">
                  Browse through developer’s profile, interview and hire
                </p>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 my-3">
              <div class="kova-summary shadow py-4 px-4">
                <p class="font-weight-bolder">Have no funds yet?</p>
                <h3
                  class="pt-2 kova-text font-weight-bold very-bold1 mx-4 mb-0"
                >
                  2,000+
                </h3>
                <p class="ctrl-size2 font-weight-bolder kova-text">
                  talents available for crowdsourcing
                </p>
                <p class=" ctrl-size3 font-weight-lighter">
                  Get access to a pool of talents interested in building your
                  well researched, market-fit idea
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="kova-text">
        <a class=" text-underlined">Explore >></a>
      </div> -->
    </div>

    <div class="container-fluid py-5 kova-bg">
      <div class="container">
        <h5 class="text-white very-bold">Your Remote Hiring Solution</h5>
        <div class="row text-left text-white mx-auto">
          <div class="col-12 col-md-6">
            <h6 class="text-white font-weight-bold mt-5">Client</h6>
            <p class="font-weight-lighter">
              We pay close attention to your hiring need by assigning you a
              dedicated account manager
            </p>
            <div class="row mx-auto text-center">
              <div class="col-12 col-sm-6 col-lg-4 ml-5 ml-sm-0">
                <div class="border rounded hiring-sol ml-2 px-2 mt-3 mx-2">
                  <h6 class="text-white font-weight-bold pt-2">Contracts</h6>
                  <p class="text-white ctrl-size2">
                    5x faster hiring experience for short term & long term
                    projects
                  </p>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-lg-4 ml-5 ml-sm-0">
                <div class="border rounded hiring-sol ml-2 px-2 mt-3 mx-2">
                  <h6 class="text-white font-weight-bold pt-2">Full-time</h6>
                  <p class="text-white ctrl-size2">
                    Hire the talent(s) you need into your team
                  </p>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-lg-4 ml-5 ml-sm-0">
                <div class="border rounded hiring-sol ml-2 px-2 mt-3 mx-2">
                  <h6 class="text-white font-weight-bold pt-2">Remote Team</h6>
                  <p class="text-white ctrl-size2">
                    Extend your development team with remote in-house talents.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="image-hire-container">
              <div class="image-hire"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container my-5">
      <div class="row pb-5">
        <div class="col-12 col-md-6 pt-5 pt-md-0">
          <p class="text-left ctrl-size2 mt-4 mt-md-0">
            TalentAlt partners with leading software skill acquisition platforms
            to access their elite talent base, validate their skill & work
            culture, place them in a continuous learning environment and connect
            them with global businesses remotely.
          </p>
        </div>
        <div class="col-12 col-md-6"></div>
      </div>
    </div>

    <div class="container-fluid white-kova-img mt-5">
      <div class="container">
        <div class="row py-5">
          <div class="col-12 col-md-6">
            <h3 class="pt-4 font-weight-bold very-bold1 mx-4 mt-md-5">
              <span style="color: #aaaaaa">Build Better,</span>
              <span class="kova-text">Build Faster</span>
            </h3>
            <p class="ctrl-size mx-md-5">
              We’ve made it superfast for you to kick-off both your short term &
              long term projects with our AI-assisted hiring tools plus an agile
              project management board.
              <router-link to="/hire"
                ><span class="kova-text font-weight-bolder"
                  >Start Building</span
                ></router-link
              >
              in minutes.
            </p>
          </div>
          <div class="col-12 col-md-6 mt-4 mt-md-0">
            <img
              class="project-board-img"
              src="../assets/KOVATEK/IMAGES/image-023.png"
              alt="kovatek project board"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Why Choose TalentAlt -->
    <div class="my-5 pt-5 ctrl-choose mx-auto container-fluid kovatek-width ">
      <h5 class="px-4 font-weight-bolder kova-text text-capitalize very-bold">
        Why Choose TalentAlt
      </h5>
      <div class="px-sm-4 mx-4 my-5 pb-4 px-3">
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-3 my-3">
            <div class="py-2">
              <div>
                <div class="choose-kovatek-round mx-auto mb-4 pt-2">
                  <img
                    src="../assets/KOVATEK/IMAGES/icon-01.png"
                    alt="icon"
                    class="mt-4"
                  />
                </div>
                <div class="choose-kovatek-white"></div>
              </div>
              <p class="ctrl-size2 font-weight-bolder kova-text">
                Software talent that matches your needs
              </p>
              <p class="ctrl-size2">
                TalentAlt provides elite workforce and freelancers that match
                your product development needs, covering advanced software
                development applications.
              </p>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 my-3">
            <div class="py-2">
              <div>
                <div class="choose-kovatek-round mx-auto mb-4 pt-2">
                  <img
                    src="../assets/KOVATEK/IMAGES/icon-02.png"
                    alt="icon"
                    class="mt-4"
                  />
                </div>
                <div class="choose-kovatek-white"></div>
              </div>
              <p class="ctrl-size2 font-weight-bolder kova-text">
                Fully vetted for you
              </p>
              <p class="ctrl-size2">
                Ensuring quality performance and delivery is our priority. At
                TalentAlt, we make sure our developers have the expertise and
                skills needed for your product development.
              </p>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 my-3">
            <div class="py-2">
              <div>
                <div class="choose-kovatek-round mx-auto mb-4 pt-2">
                  <img
                    src="../assets/KOVATEK/IMAGES/icon-03.png"
                    alt="icon"
                    class="mt-4"
                  />
                </div>
                <div class="choose-kovatek-white"></div>
              </div>
              <p class="ctrl-size2 font-weight-bolder kova-text">
                At considerable cost
              </p>
              <p class="ctrl-size2">
                A budget-fit developer workforce for your product development.
                State your hourly fee/fixed price, and you receive bids that
                fit-in perfectly for you.
              </p>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 my-3">
            <div class="py-2">
              <div>
                <div class="choose-kovatek-round mx-auto mb-4 pt-2">
                  <img
                    src="../assets/KOVATEK/IMAGES/icon-04.png"
                    alt="icon"
                    class="mt-4"
                  />
                </div>
                <div class="choose-kovatek-white"></div>
              </div>
              <p class="ctrl-size2 font-weight-bolder kova-text">
                5x faster hiring process
              </p>
              <p class="ctrl-size2">
                We make your hiring experience for contract and full time remote
                jobs super fast, with the assistance of a data-driven matching
                algorithm, connecting you with the right talents.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- How it works -->
    <div class="py-5 container mx-auto">
      <h5 class="px-4 font-weight-bolder kova-text text-capitalize very-bold">
        How TalentAlt Works
      </h5>
      <div class="">
        <div class="row mt-5 itworks-width">
          <div class="col-sm-12 col-md-6 col-lg-3 my-3">
            <div
              class="itworks py-3 px-2 border rounded text-left bg-white position-relative"
              style="z-index:99;"
            >
              <div>
                <img
                  src="../assets/KOVATEK/IMAGES/1.svg"
                  alt=""
                  class="itworks-img"
                />
                <div
                  class="itworks-label text-white text-center very-bold pt-1"
                >
                  1
                </div>
              </div>
              <p class="ctrl-size2 font-weight-bolder kova-text px-2">
                Post A Project or Tell Us About Your hiring needs
              </p>
              <p class="mt-3 ctrl-size2 px-2">
                Tell us your hiring needs or provide your project information.
                Your project details help the right talent to bid for your
                project task, and also allows our data matching system to
                recommend talents that are relevant to your project needs. You
                always have an account manager to assist you.
              </p>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 my-3">
            <div
              class="itworks p-3 border rounded text-left bg-white position-relative"
              style="z-index:99;"
            >
              <div>
                <img
                  src="../assets/KOVATEK/IMAGES/2.svg"
                  alt=""
                  class="itworks-img"
                />
                <div
                  class="itworks-label text-white text-center very-bold pt-1"
                >
                  2
                </div>
              </div>
              <p class="ctrl-size2 font-weight-bolder kova-text px-2">
                Hire the right Talent
              </p>
              <p class="mt-3 ctrl-size2 px-2">
                Developers that meet your product requirement specifications
                will bid and/or will be recommended for your project task. You
                review their profile, interview and hire.
              </p>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 my-3">
            <div
              class="itworks p-3 border rounded text-left bg-white position-relative"
              style="z-index:99;"
            >
              <div>
                <img
                  src="../assets/KOVATEK/IMAGES/4.svg"
                  alt=""
                  class="itworks-img"
                />
                <div
                  class="itworks-label text-white text-center very-bold pt-1"
                >
                  3
                </div>
              </div>
              <p class="ctrl-size2 font-weight-bolder kova-text px-2">
                Collaborate & Build
              </p>
              <p class="mt-3 ctrl-size2 px-2">
                Hire all your developers and use TalentAlt project board to
                manage & track all your project activities. Your product
                development is enriched with TalentAlt management assistance.
              </p>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3 my-3">
            <div
              class="itworks p-3 border rounded text-left bg-white position-relative"
              style="z-index:99;"
            >
              <div>
                <img
                  src="../assets/KOVATEK/IMAGES/5.svg"
                  alt=""
                  class="itworks-img"
                />
                <div
                  class="itworks-label text-white text-center very-bold pt-1"
                >
                  4
                </div>
              </div>
              <p class="ctrl-size2 font-weight-bolder kova-text px-2">
                Easy Payment
              </p>
              <p class="mt-3 ctrl-size2 px-2">
                Fund your project account and initiate payment either based on
                milestone goals you have set or at a fixed-price to your
                developer team, only when you are 100% satisfied.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="itworks-bg-img">
      <!-- <router-link to="/how-it-works" class="kova-text">
      <a class=" text-underlined">See more >></a>
    </router-link> -->
      <div class="itworks-btn text-center w-100">
        <router-link to="/vetting-process">
          <button
            class="btn-kovatek rounded px-4 py-2 ctrl-size2 text-uppercase font-weight-bold"
          >
            view vetting process
          </button>
        </router-link>
      </div>
    </div>

    <div class="pb-5 container-fluid position-relative" style="top: -100px">
      <h5 class="px-4 font-weight-bolder kova-text text-capitalize very-bold">
        Trusted By Hundreds of Leading Global Businesses & Partners
      </h5>
      <div class="px-md-5 mx-auto" style="max-width: 720px;">
        <div class="d-flex flex-wrap w-100 justify-content-between pt-5">
          <div class="sponsors">
            <img src="../assets/KOVATEK/IMAGES/sponsor-01.png" alt="" />
          </div>
          <div class="sponsors mt-3">
            <img src="../assets/KOVATEK/IMAGES/sponsor-02.png" alt="" />
          </div>
          <div class="sponsors mt-3">
            <img src="../assets/KOVATEK/IMAGES/sponsor-03.png" alt="" />
          </div>
          <div class="sponsors mt-3">
            <img src="../assets/KOVATEK/IMAGES/sponsor-04.png" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="container mb-5">
      <h5
        class="px-4 font-weight-bolder kova-text text-capitalize very-bold mb-5"
      >
        We have fully vetted talents for your
      </h5>
      <div class="row pb-5">
        <div class="col-12 col-lg-6 px-5 px-sm-4 px-md-0">
          <div class="row border p-2">
            <div class="col-12 col-md-6">
              <div v-bind:class="width > 768 ? 'text-left' : 'text-center'">
                <div class="vetted-img">
                  <img src="../assets/KOVATEK/IMAGES/icon-07.png" />
                </div>
                <div class="text-left">
                  <h5
                    class="ctrl-size font-weight-bold kova-text mt-md-4 ctrl-vetted-text"
                  >
                    MVP
                  </h5>
                  <div class="">
                    <p class="mb-sm-3 ctrl-size2">
                      Need developer(s) for your minimum viable product (mvp)
                      development that fit your budget? Get a quality service
                      from our top rated developers
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div v-bind:class="width > 768 ? 'text-left' : 'text-center'">
                <div class="vetted-img">
                  <img src="../assets/KOVATEK/IMAGES/icon-05.png" />
                </div>
                <div class="text-left">
                  <h5
                    class="ctrl-size font-weight-bold kova-text mt-md-4 ctrl-vetted-text"
                  >
                    Code Review
                  </h5>
                  <div class="">
                    <p class="mb-sm-3 ctrl-size2">
                      Need a senior developer to review your code base and
                      provide you with a full report on code quality, security
                      and refactoring? Access pool of senior engineers on
                      TalentAlt.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div v-bind:class="width > 768 ? 'text-left' : 'text-center'">
                <div class="vetted-img">
                  <img src="../assets/KOVATEK/IMAGES/icon-08.png" />
                </div>
                <div class="text-left">
                  <h5
                    class="ctrl-size font-weight-bold kova-text mt-md-4 ctrl-vetted-text"
                  >
                    Product Scaling
                  </h5>
                  <div class="">
                    <p class="mb-sm-3 ctrl-size2">
                      Need integrations and more user satisfaction to reach
                      higher revenue and users’ growth? Leverage on cost-cutting
                      elite workforce on TalentAlt.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div v-bind:class="width > 768 ? 'text-left' : 'text-center'">
                <div class="vetted-img">
                  <img
                    src="../assets/KOVATEK/IMAGES/icon-06.png"
                    style="width:90px; height:90px"
                    class="mt-4 "
                  />
                </div>
                <div class="text-left">
                  <h5
                    class="ctrl-size font-weight-bold kova-text mt-md-4 ctrl-vetted-text"
                  >
                    Research & Analysis
                  </h5>
                  <div class="">
                    <p class="mb-sm-3 ctrl-size2">
                      Top data engineers are available for research, review and
                      analyze data for your project growth.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 px-md-5 py-5">
          <div
            id="carouselExampleIndicators"
            class="carousel slide"
            data-ride="carousel"
          >
            <ol class="carousel-indicators">
              <li
                data-target="#carouselExampleIndicators"
                data-slide-to="0"
                class="active"
              ></li>
              <li
                data-target="#carouselExampleIndicators"
                data-slide-to="1"
              ></li>
              <li
                data-target="#carouselExampleIndicators"
                data-slide-to="2"
              ></li>
            </ol>
            <div class="carousel-inner">
              <div class="carousel-item active">
                <Testimony
                  image="testimony.png"
                  testimony="TalentAlt helped us focus on the development of our project withour having to move from platform to platform, it made our product building process effective because we could
                                monitor the activities of our developers on the platform. We look forward to using their services over time."
                  name="Paul Sunday"
                  company="Founder Storydium"
                />
              </div>
              <div class="carousel-item">
                <Testimony
                  image="testimony-1.png"
                  testimony="With a number of jobs to be done, we needed remote talents with the right expertise to achieve our desired result, this was made possible with the help of TalentAlt."
                  name="Adewale Adedamola"
                  company="CEO, Aorthar"
                />
              </div>
              <div class="carousel-item">
                <Testimony
                  image="testimony-2.png"
                  testimony="Our hiring experience was made easier with TalentAlt, not to mention how helpful the account manager was, the developers delivered excellently and right on time."
                  name="Lucky Uwakwe"
                  company="Co-founder, SaBiii X"
                />
              </div>
            </div>
            <a
              class="carousel-control-prev kova-text text-danger"
              href="#carouselExampleIndicators"
              role="button"
              data-slide="prev"
            >
              <!-- <span class="carousel-control-prev-icon text-danger bg-danger" aria-hidden="true"></span> -->
              <a-icon
                type="left"
                style="font-size: 30px; color: #20409a; margin-left: -50px"
              />
              <span class="sr-only">Previous</span>
            </a>
            <a
              class="carousel-control-next"
              href="#carouselExampleIndicators"
              role="button"
              data-slide="next"
            >
              <!-- <span class="carousel-control-next-icon" aria-hidden="true"></span> -->
              <a-icon
                type="right"
                style="font-size: 30px; color: #20409a; margin-right: -50px"
              />
              <span class="sr-only">Next</span>
            </a>
          </div>
          <div class=""></div>
        </div>
      </div>
    </div>
    <RemoteTeam />
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import TopRatedDev from '@/components/TopRatedDev.vue';
import Testimony from '@/components/Testimony.vue';
import RemoteTeam from '@/components/RemoteTeam.vue';
import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';
// import getScreenSize from '../getScreenSize';

export default {
  name: 'landing',
  data() {
    return {
      show: false,
      width: window.innerWidth,
      height: window.innerHeight,
      typing: true,
      styleObject: {
        position: 'fixed',
        margin: 'auto',
        top: 0 + 'px',
        left: 0 + 'px',
        bottom: 'auto',
        right: 'auto',
        boxSizing: 'border-box',
        width: 786 + 'px',
      },
      searchData: [
        'Web Application',
        'Mobile Application',
        'DevOps',
        'Blockchain',
        'Artificial Intelligence',
        'UI/UX Design',
        'CyberSecurity',
        'Data Engineering',
        'Machine Learning',
        'Mobile Deveper in Mauritus',
        'Blockchain Developer in Nigeria',
        'Data Analyst in Los Angeles',
        'DevOps Engineer in S.A.',
        'UI/UX Designer in Lagos',
        'E-Commerce Developer in Kampala',
        'Front-end Developer in Nairobi',
        'A.I. Developer in Mumbai',
        'Cloud Engineer Odense',
        'Product Manage in Cape Town',
      ],
    };
  },
  components: {
    Navbar,
    Footer,
    TopRatedDev,
    VueperSlides,
    VueperSlide,
    Testimony,
    RemoteTeam,
  },
  methods: {
    onFocus() {
      this.typing = false;
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    });
  },
};
</script>

<style scoped>
.block-parallax-1 {
  overflow: hidden;
  position: relative;
}
.block-parallax-1 .parallax-bg {
  background-attachment: fixed;
  background-image: url('http://bygaga.com.ua/uploads/posts/1354003535_podborka_krasivih_moto_759-58.jpg');
  background-position: 0px 0px;
  background-repeat: repeat;
  height: 100%;
  position: absolute;
  width: 100%;
  min-width: 1170px;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  background-size: cover;
}
.block-parallax-1 .md-box {
  padding: 200px 0 200px;
  background: rgba(0, 0, 0, 0.75);
  position: relative;
  height: 100%;
  text-align: center;
}
.block-parallax-1 .md-box h1 {
  color: #fff;
}

.block-parallax-2 .parallax-bg {
  background-image: url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_z73DvFVC1ek9ZsGdCpvpDW_AwRqOWgG6IP2wOXrVibxz_EDV');
}
.carousel-indicators li {
  margin-top: 50px;
  background-color: #91adfa;
  background-color: rgba(70, 70, 70, 0.25);
}
.carousel-indicators .active {
  background-color: #20409a;
}
/* .carousel-item {
    height: 350px;
}
.carousel-indicators li {
    width: 10px;
    height: 10px;
    border-radius: 100%;
} */
.carousel-indicators {
  bottom: -50px;
}
input::placeholder {
  color: #fff;
  font-size: 12px;
  font-weight: lighter;
}
input:focus::-webkit-input-placeholder {
  color: #fff;
}
input:focus::-moz-input-placeholder {
  color: #fff;
}

.home-img {
  /* background:  url('../assets/KOVATEK/PNGss/Mask Group 7.png'), url('../assets/KOVATEK/PNGss/Banner Wallpaper.png'); */
  background: url('../assets/KOVATEK/IMAGES/image-020.png');
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 100%;
  height: auto;
}
.landing-font-size {
  font-size: 18px;
}
.title-size {
  font-size: 24px;
}
.ctrl-size {
  font-size: 16px;
}
.ctrl-size1 {
  font-size: 14px;
}
.ctrl-size2 {
  font-size: 12px;
}
.ctrl-size3 {
  font-size: 10px;
}
.available-devs-width {
  max-width: 850px;
  margin: auto;
}
.available-devs {
  height: 150px;
  width: 150px;
  border-radius: 10px;
  transition: 0.1s;
}
.available-devs:hover {
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
}
.services-width {
  width: 75%;
}
.kova-summary {
  background: #f6fbf9;
  height: 200px;
}
.hiring-sol {
  min-height: 120px;
  width: 150px;
}
.hire-section {
  height: 100vh;
  background: url('../assets/KOVATEK/IMAGES/image-022.png');
  background-attachment: fixed;
  overflow: hidden;
}

.hire-section div {
  position: relative;
  max-width: 100%;
}
.remote-hire-img {
  background: url('../assets/KOVATEK/IMAGES/image-021.png');
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 1000px;
  height: 300px;
}
.image-hire {
  position: absolute;
  top: 30px;
  left: 100px;
  background: url('../assets/KOVATEK/IMAGES/image-029.png');
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 320px;
  height: 350px;
}
.white-kova-img {
  background: url('../assets/KOVATEK/IMAGES/image-022.png');
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 100%;
  height: auto;
}
.project-board-img {
  height: 350px;
}
.choose-kovatek-round {
  height: 125px;
  width: 125px;
  border-radius: 50%;
  background-color: #d0d9ea;
  /* border: solid 5px #D0D9EA; */
}
.choose-kovatek-white {
  position: absolute;
  top: 5px;
  left: 0px;
  right: 10px;
  margin-left: auto;
  margin-right: auto;
  height: 120px;
  width: 120px;
  border-radius: 50%;
  border: solid 5px #fff;
}
.itworks {
  min-height: 480px;
}
.itworks-img {
  height: 220px;
}
.itworks-bg-img {
  position: relative;
  top: -240px;
  background: url('../assets/KOVATEK/IMAGES/image-028.png');
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 100%;
  height: 350px;
}
.itworks-label {
  position: absolute;
  top: 185px;
  left: 20px;
  /* bottom: 0; */
  width: 40px;
  height: 40px;
  background-color: #20409a;
  font-size: 20px;
}
.itworks-btn {
  position: absolute;
  top: 250px;
}
.sponsors img {
  width: 120px;
}
.vetted-img img {
  width: 120px;
  height: 120px;
}
.vetted-img-1 img {
  width: 80px;
  height: 80px;
}
.w-90 {
  width: 90%;
}
.testimony {
  height: 400px;
}
.w-94 {
  width: 94%;
}
.ctrl-shadow {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
/* .styled-btn{
  color:#fff;
  border-radius: 25px;
  outline: 0;
  transition: 0.2s;
  font-size: 10px;
}
.styled-btn:hover {
  box-shadow: 0 2px 4px rgba(0,0,0, 0.7);
}
.get-started{
    background:linear-gradient(to right, rgb(75,179,142), rgb(28,71,152));
    border: 0;
    width: 240px;
    height:35px;
    box-shadow: 0 0px 4px rgba(0,0,0, 0.3);
} */
.icon-size {
  font-size: 16px;
}
.icon-width {
  width: 200px;
  height: 200px;
}
/* .btn-dev-signup{
  background:linear-gradient(to right, rgb(75,179,142), rgb(28,71,152));
  border: 0;
  box-shadow: 0 0px 4px rgba(0,0,0, 0.3);
}
.btn-findjobs{
  background:linear-gradient(to right, rgb(254,151,22), rgb(241,100,45));
  border: 0;
  box-shadow: 0 0px 4px rgba(0,0,0, 0.3);
} */
.very-bold {
  font-weight: 900;
  text-shadow: 2px 0;
  letter-spacing: 2px;
}
.very-bold1 {
  font-weight: 900;
  text-shadow: 2px 0;
  letter-spacing: 2px;
  font-size: 25px;
}
@media screen and (min-width: 992px) and (max-width: 1325px) {
}
@media screen and (min-width: 992px) and (max-width: 1195px) {
  .project-board-img {
    height: 300px;
  }
  .itworks-img {
    height: 180px;
  }
  .itworks-label {
    top: 150px;
  }
}

@media screen and (min-width: 769px) and (max-width: 991px) {
  .project-board-img {
    height: 220px;
  }
  .itworks {
    min-height: 380px;
  }
  .itworks-img {
    width: 100%;
    height: 300px;
  }
  .itworks-label {
    top: 260px;
  }
}
@media screen and (max-width: 768px) {
  .available-devs-width {
    max-width: 450px;
    margin: auto;
  }
  .devs-skills-img {
    margin-top: 20px;
    width: 40px;
  }
  .image-hire-container {
    height: 250px;
  }
  .ctrl-text-align {
    text-align: center;
  }
  .itworks {
    min-height: 380px;
  }
  .itworks-width {
    max-width: 400px;
    margin: auto;
  }
  .itworks-img {
    width: 100%;
    height: 300px;
  }
  .itworks-label {
    top: 260px;
  }
}

@media screen and (max-width: 540px) {
  .project-board-img {
    height: 180px;
  }
  .itworks-img {
    width: 100%;
    height: 300px;
  }
  .itworks-label {
    top: 250px;
  }
  .image-hire {
    left: 0;
    right: 0;
    margin-right: auto;
    margin-left: auto;
  }
}
</style>
